import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import FeatureModalChecker, {
  CHECKED_FEATURES,
} from 'modules/timeoff/components/FeatureModalChecker'

interface Props {
  onClose: () => void
  onSuccess: (leaveTypeName: string) => void
}

const AddLeaveTypeModal = ({ onClose, onSuccess }: Props) => {
  const form = useMemo(() => new Form({ name: '' }, { name: 'string' }), [])

  const handleOnSubmit = () => {
    const leaveTypeName = form.get('name').value
    onSuccess(leaveTypeName)
  }

  const isDisabled = !form.get('name').value

  return (
    <FeatureModalChecker
      feature={CHECKED_FEATURES.create_custom_leave_types ?? 'create_custom_leave_types'}
      onClose={onClose}
    >
      <Modal
        illustration="document-edit"
        title={i18n.t('settings.leave_types.add_modal.title')}
        description={i18n.t('settings.leave_types.add_modal.description')}
        onSubmit={handleOnSubmit}
        onClose={onClose}
        footer={
          <>
            <Button onClick={onClose} type="secondary">
              {i18n.t('common.cancel')}
            </Button>
            <Button
              disabled={isDisabled}
              submit
              extra={{ 'data-intercom-target': 'add-leave-type-button-continue' }}
            >
              {i18n.t('common.continue')}
            </Button>
          </>
        }
      >
        <Text
          label={i18n.t('settings.leave_types.add_modal.name_field')}
          field={form.get('name')}
          extra={{ 'data-intercom-target': 'leave-type-name-input' }}
        />
      </Modal>
    </FeatureModalChecker>
  )
}

export default observer(AddLeaveTypeModal)
